<div class="section-main-padding" *ngIf="route.url != '/account/checkout'">
    <h1 class="page-title">Account</h1>
    <div class="acc-wrp">
        <div class="acc-sidebar">
            <div class="top">
                <img src="assets/images/avatar.jpg" alt="avatar">
                <span>Navneet</span>
            </div>
            <div class="sidebar-items">
                <ul>
                    <li>
                        <a [routerLink]="['info']" [routerLinkActive]="['active']">Account Info</a>
                    </li>
                    <li>
                        <a [routerLink]="['order']" [routerLinkActive]="['active']">Order</a>
                    </li>
                    <li>
                        <a [routerLink]="['address']" [routerLinkActive]="['active']">Address</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="acc-outlet">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<section *ngIf="route.url == '/account/checkout'">
    <router-outlet></router-outlet>
</section>